import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  page: {
    textAlign: 'start',
    padding: 0,
    marginBottom: 16,
  },
  inputs: {
    display: 'flex',
    gap: 18,
    maxWidth: 500,
    '& > div': {
      width: '100%'
    },
    [theme.breakpoints.down('450')]: {
      flexDirection: 'column'
    }
  }
}))